import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import frErrors from './locales/fr/errors.json';
import enErrors from './locales/en/errors.json';
import frSupport from './locales/fr/support.json';
import enSupport from './locales/en/support.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'fr',           // default language
    fallbackLng: 'en',   // fallback when a key is missing in FR
    interpolation: { escapeValue: false },
    resources: {
      fr: { errors: frErrors, support: frSupport },
      en: { errors: enErrors, support: enSupport },
    },
  });

export default i18n;
